import keyBy from 'lodash/keyBy'
import omit from 'lodash/omit'

import { RootState } from 'types'
import { Action } from 'redux/actions'
import { TodosActions } from 'redux/actions/todos'

export default function reduce(
  state: RootState['todos'] = {
    activeId: undefined,
    highlightedId: undefined,
    records: {},
  },
  action: Action,
): RootState['todos'] {
  switch (action.type) {
    case TodosActions.UPSERT_TODO: {
      const { todo } = action.payload
      return { ...state, records: { ...state.records, [todo.id]: todo } }
    }

    case TodosActions.UPSERT_TODOS: {
      const { todos } = action.payload
      return { ...state, records: { ...state.records, ...keyBy(todos, todo => todo.id) } }
    }

    case TodosActions.DELETE_TODO: {
      const { id } = action.payload
      const { activeId } = state
      return { ...state, activeId: activeId === id ? undefined : activeId, records: omit(state.records, id) }
    }

    case TodosActions.SET_ACTIVE_TODO: {
      const { id } = action.payload
      return { ...state, activeId: id }
    }

    case TodosActions.SET_HIGHLIGHTED_TODO: {
      const { id } = action.payload
      return { ...state, highlightedId: id }
    }

    default:
      return state
  }
}
